module.exports = __webpack_public_path__ + "static/media/Барабанов Е.А., Быков В.В..c445b035.pdf";